/* Built In Imports */
import { Link } from '@chakra-ui/next-js';
import { Box, Flex, Image, Text } from '@chakra-ui/react';
import config from '@config';
/* External Imports */
/* Components */
/* Services */
/**
 * Render Error 404 Component
 * @returns {ReactElement} ILA404 component
 */
const ILA404 = () => {
  return (
    <Flex w="100%" flexWrap="wrap" pos="relative">
      <Box
        w={{
          base: '100%',
          sm: '100%',
          md: '100%',
          lg: '100%',
        }}
      >
        <Box>
          <Box
            display={'flex'}
            justifyContent={'center'}
            flexDirection={{ base: 'column', lg: 'row' }}
            alignItems={'center'}
            gap={{ base: 0, lg: '68px' }}
            paddingTop={{ base: '60px', sm: '60px', lg: '100px' }}
            paddingBottom={{ base: '50px', lg: '180px' }}
            bgSize="cover"
          >
            <Box
              display={'flex'}
              flexDirection={'column'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <Image
                src={`${config?.imgPath}/d/46272/1707210748-ila_404.png`}
                alt="error Image"
                height={{ base: '130px', md: '200px', lg: '288px' }}
              />
              <Text
                marginTop={{ base: '16px', lg: '33px' }}
                textTransform={'uppercase'}
                fontFamily={'var(--FedraSansCondensedMedium)'}
                color={'#D4D4FA'}
                fontSize={{ base: '28px', md: '58px' }}
                fontWeight={'800'}
                textAlign={'center'}
              >
                Page Not Found
              </Text>
            </Box>
            <Box
              paddingTop={{ base: '41px', md: '48px' }}
              height={{ base: '298px', sm: '328px' }}
              fontWeight="350"
              fontFamily="var(--FedraSansStd-book)"
              color="#F8F8F8"
              fontSize={{ base: '18px', sm: '16px', md: '20px' }}
            >
              <Box>
                <Text
                  textAlign="center !important"
                  lineHeight="{{ base: '1.72', sm: '1.72', md: '1.55' }}"
                  marginLeft="{{ base: '10%', sm: '10%', md: '2%' }}"
                >
                  A wise man once asked…
                </Text>
                <Text
                  textAlign="center !important"
                  lineHeight="1.35"
                  marginLeft="2%"
                  whiteSpace={'nowrap'}
                >
                  If you’ve come to a page that can not be found
                </Text>
                <Text
                  textAlign="center !important"
                  lineHeight="1.35"
                  marginLeft="2%"
                  paddingBottom="20px"
                >
                  Does it actually exist?
                </Text>
              </Box>
              <Box textAlign="center" marginTop="40px">
                <Link href="/sadhguru-academy">
                  <Box textAlign="center" marginTop="40px">
                    <Box
                      fontFamily="var(--FedraSansStd-medium)"
                      background="#F27123"
                      color="#FAF7F0"
                      fontWeight="500"
                      fontSize="22px"
                      padding="14px 20px"
                      display="inline"
                      border="none"
                      width="252px"
                      height="52px"
                      flexShrink="0"
                      boxShadow="0px 0px 44px 20px rgba(0, 0, 0, 0.25)"
                      _hover={{
                        borderColor: '#CF4520',
                        color: '#FFFFFF',
                        background: '#CF4520',
                      }}
                      _active={{
                        border: 'none',
                        background: '#FFA735',
                      }}
                      cursor="pointer"
                      textTransform="uppercase"
                    >
                      Back To Home
                    </Box>
                  </Box>
                </Link>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Flex>
  );
};
export default ILA404;
